import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';

export const Cycle = () => <DirectionsBikeIcon fontSize="small" />;
